import { Splat } from '@react-three/drei';

export type GaussianSplattingProps = {
  src: string;
  position: [number, number, number];
  rotation: [number, number, number];
};

export function GaussianSplatting(props: GaussianSplattingProps) {
  const { src, position = [0, 0, 0], rotation = [0, 0, 0] } = props;

  return <Splat visible={true} position={position} rotation={rotation} src={src} />;
}

export default GaussianSplatting;
